import React from "react";
import { FaHeart, FaCog, FaDesktop } from "react-icons/fa";
import { SlDiamond } from "react-icons/sl";

const Services = () => {
  return (
    <div className="py-[64px] space-y-2" id="services">
      <h3 className="font-medium text-2xl text-zinc-100 uppercase text-center">
        SERVICES
      </h3>
      <p className="text-italics text-center mb-4">Key Features Provided</p>
      <div className="grid p-6 grid-cols-1 md:grid-cols-4 gap-4 max-w-4xl mx-auto justify-center items-start">
        <div className="flex flex-col items-center justify-center h-full border-b-4 md:rounded md:border-t-2 md:border-b-2 p-4 space-y-4">
          <FaDesktop size={"40px"} className="text-indigo-500" />
          <p className="font-medium uppercase my-2">Responsive</p>
          <p className="text-sm text-justify">
            Built to look and perform beautifully on all types of devices, with
            a page structure that is logical and helps users (and search
            engines) browse efficiently.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center h-full border-b-4 md:rounded md:border-t-2 md:border-b-2 p-4 space-y-4">
          <FaHeart size={"40px"} className="text-indigo-500" />
          <p className="font-medium  uppercase my-2">Passion</p>
          <p className="text-sm text-justify ">
            Front-end and back-end web development and design, from wireframes
            and UI/UX design to Full stack web Application.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center h-full border-b-4 md:rounded md:border-t-2 md:border-b-2 p-4 space-y-4">
          <SlDiamond size={"40px"} className="text-indigo-500" />
          <p className="font-medium  uppercase my-2">Design</p>
          <p className="text-sm text-justify ">
            Human-centered approach to all design decisions so that products
            feel custom built for the target audience and easy to navigate.
          </p>
        </div>
        <div className="flex flex-col items-center justify-center h-full md:rounded md:border-t-2 md:border-b-2 p-4 space-y-4">
          <FaCog size={"40px"} className="text-indigo-500" />
          <p className="font-medium  uppercase my-2">Support</p>
          <p className="text-sm text-justify ">
            Offer friendly and professional support to all customer. Ready to
            assist your business to grow 24/7.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Services;
